import { createAction, createAsyncAction } from 'typesafe-actions';

import {
    AgeGroupEntity,
    CountryLocationSdi,
    DataCollectionResource,
    DataProject,
    Dataset,
    Organization,
    ResourceCategory,
    Round,
    SmartOptionResource,
} from '@portal/common/types';

export const getOrganizationsAsync = createAsyncAction(
    'GET_ORGANIZATIONS_REQUEST',
    'GET_ORGANIZATIONS_SUCCESS',
    'GET_ORGANIZATIONS_FAILURE'
)<void, Organization[], string>();

export const getDataCollectionsAsync = createAsyncAction(
    'GET_DATA_COLLECTIONS_REQUEST',
    'GET_DATA_COLLECTIONS_SUCCESS',
    'GET_DATA_COLLECTIONS_FAILURE'
)<void, DataCollectionResource[], string>();

export const getCategoriesAsync = createAsyncAction(
    'GET_CATEGORIES_REQUEST',
    'GET_CATEGORIES_SUCCESS',
    'GET_CATEGORIES_FAILURE'
)<void, ResourceCategory[], string>();

export const getDatasetsAsync = createAsyncAction(
    'GET_DATASETS_REQUEST',
    'GET_DATASETS_SUCCESS',
    'GET_DATASETS_FAILURE'
)<undefined, Dataset[], string>();

export const getDataProjectsAsync = createAsyncAction(
    'GET_DATA_PROJECTS_REQUEST',
    'GET_DATA_PROJECTS_SUCCESS',
    'GET_DATA_PROJECTS_FAILURE'
)<void, DataProject[], string>();

export const getRoundsAsync = createAsyncAction(
    'GET_ROUNDS_REQUEST',
    'GET_ROUNDS_SUCCESS',
    'GET_ROUNDS_FAILURE'
)<undefined, Round[], string>();

export const getAgeGroupsAsync = createAsyncAction(
    'GET_AGE_GROUPS_REQUEST',
    'GET_AGE_GROUPS_SUCCESS',
    'GET_AGE_GROUPS_FAILURE'
)<undefined, AgeGroupEntity[], string>();

export const getCountryLocationsSdi = createAsyncAction(
    'GET_COUNTRY_LOCATIONS_SDI_REQUEST',
    'GET_COUNTRY_LOCATIONS_SDI_SUCCESS',
    'GET_COUNTRY_LOCATIONS_SDI_FAILURE'
)<undefined, CountryLocationSdi[], string>();

export const getAllSmartOptionsAsync = createAsyncAction(
    'GET_SMART_OPTIONS_REQUEST',
    'GET_SMART_OPTIONS_SUCCESS',
    'GET_SMART_OPTIONS_FAILURE'
)<undefined, SmartOptionResource[], string>();

export const addSmartOption = createAction('ADD_SMART_OPTION')<SmartOptionResource>();

export const removeSmartOption = createAction('REMOVE_SMART_OPTION')<number>();

export const requiredDataLoaded = createAction('REQUIRED_DATA_LOADED')();
